export function inSoftSoakTrioRange(dealer, pool) {
  if (dealer.country === 'CA') {
    return pool.volume >= 1000 && pool.volume <= 1900;
  }

  return pool.volume >= 275 && pool.volume <= 500;
}
